import { Component, OnInit } from '@angular/core';
import { OTScheduleService } from "../../shared/services/ot-schedule/ot-schedule.service";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { first } from "rxjs/operators";

@Component({
  selector: 'app-ot-schedule-upload',
  templateUrl: './ot-schedule-upload.component.html',
  styleUrls: ['./ot-schedule-upload.component.scss']
})
export class OtScheduleUploadComponent implements OnInit {

  filter: any = {
    key: ""
  };
  /*** for paginaton start */
  pageSize = 25;
  currentPage = 1;
  otScheduleCount = 0;
  doc: any;
  downloadurl = "";
  /** end pagination */
  otSchedule: any = [];
  sender = "ot-schedule-upload";


  constructor(
    private router: Router,
    private otScheduleService: OTScheduleService,
  ) { }

  ngOnInit(): void {
    this.searchOTSchedule();
  }


  uploadCsrc() {
    this.router.navigate(["admin/upload-ot-schedule"]);
  }


  searchOTSchedule() {
    this.otScheduleService
      .searchOTSchedule(this.currentPage, this.pageSize, this.filter)
      .pipe(first())
      .subscribe((res: any) => {
        if (res) {
          this.otScheduleCount = res["count"];
          this.otSchedule = res["data"];
        }
      });
  }


  fetchexamData(e: any) {
    this.currentPage = e;
    this.searchOTSchedule();
  }

  clear() {
    this.filter.key = "";
    this.searchOTSchedule();
  }

  onDelete() {
    Swal.fire({
      title: "Are you sure?",
      text: "OT Schedule Upload data will be deleted. This action can't be reversed!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it"
    }).then(result => {
      if (result.value) {
        Swal.fire("Deleted!", "OT Schedule Upload is deleted.", "success");
        // this.otScheduleService
        //   .deleteAll(this.otSchedule)
        //   .pipe(first())
        //   .subscribe(res => {
        //     this.searchOTSchedule();
        //   });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "OT Schedule Upload is Not Deleted:)", "error");
      }
    });
  }
}
